import { ReactNode } from 'react';

import { ProfileDto, ShiftType } from '@clh/api-client';

import { AssignNurse } from './assign-nurse';

export const createNurseProfileFieldRenderer = (
    shiftType: ShiftType,
    isEditing: boolean,
    onEdit: () => void,
    onClose: () => void
): ((nurseProfile: ProfileDto) => ReactNode) => {
    const renderNurseProfile = (nurseProfile: ProfileDto) => {
        if (nurseProfile) {
            return (
                <>
                    {nurseProfile.firstName} {nurseProfile.lastName}
                </>
            );
        }

        if (shiftType === ShiftType.Orientation) {
            return null;
        }

        if (isEditing) {
            return <AssignNurse close={onClose} />;
        }

        return <a onClick={onEdit}>Assign Nurse</a>;
    };

    renderNurseProfile.displayName = 'NurseProfileFieldRenderer';
    return renderNurseProfile;
};
